import React, { useEffect, useState } from "react";
import { loadBlogDetails, loadSection } from "../../services/contentSource";
import { Link } from "react-router-dom";
import { toSlug } from "../../utils/slug";
import headerFallback from "../../data/home/blogHeader.json";

const BlogSection = () => {
  const [blogs, setBlogs] = useState<any[]>([]);
  const [header, setHeader] = useState<any>(headerFallback);

  useEffect(() => {
    loadBlogDetails()
      .then(data => setBlogs((data || []).slice(0, 3)))
      .catch(console.error);
    loadSection("homeBlog", headerFallback as any).then(({ data: main }) => {
      if (main) setHeader(main);
    });
  }, []);

  if (!blogs.length) return null;

  return (
    <section className="blog-area">
      <div className="container">
        <div className="blog-area-inner section-spacing">
          <div className="section-header">
            <div className="section-title-wrapper">
              <div className="title-wrapper">
                <h2 className="section-title has_text_move_anim">
                  {header.title}
                </h2>
              </div>
            </div>

            <div
              className="content-last has_fade_anim"
              data-fade-from="right"
              data-delay="0.45"
            >
              <div className="text-wrapper">
                <p className="text">
                  {header.subtitle}
                </p>
              </div>
              <div className="btn-wrapper">
                <a
                  href="/blogs"
                  className="wc-btn wc-btn-underline btn-text-flip"
                >
                  <span data-text={header.buttonText}>{header.buttonText}</span>
                  <img
                    className="show-light"
                    src="/assets/imgs/icon/arrow-right-half.webp"
                    alt="arrow" loading="lazy" decoding="async" />
                  <img
                    className="show-dark"
                    src="/assets/imgs/icon/arrow-right-half-light.webp"
                    alt="arrow" loading="lazy" decoding="async" />
                </a>
              </div>
            </div>
          </div>

          <div className="blogs-wrapper-box">
            <div className="blogs-wrapper">
              {blogs.map((blog: any, index: number) => (
                <div
                  className="has_fade_anim"
                  data-fade-from="left"
                  data-delay={`0.${15 + index * 15}`}
                  key={blog.id || blog._id}
                >
                  <Link
                    to={`/blogs/${toSlug(blog.title, blog.id || blog._id)}`}
                    className="blog-link-button"
                    style={{ display: "block", textAlign: "inherit", width: "100%" }}
                  >
                    <article className="blog">
                      <h2 className="title text-underline">{blog.title}</h2>
                      <div className="thumb">
                        <img src={blog.mainImage} alt={blog.title} loading="lazy" decoding="async" />
                      </div>
                      <p className="text line-clamp-4">{blog.paragraphs?.[0]}</p>
                      <div className="meta-list">
                        <h3 className="name">{blog.quote?.author}</h3>
                        <span className="meta">{(blog.tags || []).join(", ")} - {blog.date}</span>
                      </div>
                    </article>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
